import { render } from "./BaseCheckBox.vue?vue&type=template&id=36b87935&scoped=true"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"

import "./BaseCheckBox.vue?vue&type=style&index=0&id=36b87935&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b87935"]])

export default __exports__